import React from "react";
import Explore from "@mui/icons-material/Explore";
import School from "@mui/icons-material/School";
import Notes from "@mui/icons-material/Notes";
import Timeline from "@mui/icons-material/Timeline";
import Settings from "@mui/icons-material/Settings";
import BubbleChart from "@mui/icons-material/BubbleChart";
import MenuBook from "@mui/icons-material/MenuBook";
import Email from "@mui/icons-material/Email";
import ContactSupport from "@mui/icons-material/ContactSupport";
import EmojiEvents from "@mui/icons-material/EmojiEvents";
import config from "./config";

const nav = {
  teachSideNav: [
    {
      name: "classrooms",
      url: "/classrooms",
      icon: <School />,
    },
    {
      name: "explore",
      url: "/explore",
      icon: <Explore />,
    },
    {
      name: "courses",
      url: "/courses",
      icon: <BubbleChart />,
    },
    // {
    //   name: "library",
    //   url: "/library",
    //   icon: <LibraryBooks />,
    //   open: true,
    //   links: [
    //     {
    //       name: "roleplays",
    //       url: "/roleplays",
    //       icon: <Forum />,
    //     },
    //     {
    //       name: "bots",
    //       url: "/bots",
    //       icon: <Face />,
    //     },
    //     {
    //       name: "courses",
    //       url: "/courses",
    //       icon: <BubbleChart />,
    //     },
    //   ],
    // },
    // {
    //   name: "activity",
    //   url: "/activity",
    //   icon: <Timeline />,
    // },
    // {
    //   divider: true
    // },
    {
      name: "settings",
      url: "/settings",
      icon: <Settings />,
    },
    {
      divider: true,
    },
    {
      name: "faqs",
      url: `${config.SITE_URL}/faq`,
      icon: <ContactSupport />,
      external: true,
    },
    {
      name: "guides",
      url: `${config.SITE_URL}/guides`,
      icon: <MenuBook />,
      external: true,
    },
    {
      name: "contact",
      url: "/contact",
      icon: <Email />,
    },
  ],
  learnSideNav: [
    {
      name: "classrooms",
      url: "/classrooms",
      icon: <School />,
    },
    {
      name: "activity",
      url: "/activity",
      icon: <Timeline />,
    },
    {
      name: "achievements",
      url: "/achievements",
      icon: <EmojiEvents />,
    },
    {
      name: "settings",
      url: "/settings",
      icon: <Settings />,
    },
    {
      name: "contact",
      url: "/contact",
      icon: <Email />,
    },
  ],
  teachBottomNav: [
    {
      name: "classrooms",
      url: "/classrooms",
      icon: <School />,
    },
    {
      name: "explore",
      url: "/explore",
      icon: <Explore />,
    },
    {
      name: "courses",
      url: "/courses",
      icon: <BubbleChart />,
    },
    // {
    //   name: "activity",
    //   url: "/activity",
    //   icon: <Timeline />,
    // },
    {
      name: "settings",
      url: "/settings",
      icon: <Settings />,
    },
  ],
  learnBottomNav: [
    {
      name: "classrooms",
      url: "/classrooms",
      icon: <School />,
    },
    {
      name: "activity",
      url: "/activity",
      icon: <Timeline />,
    },
    {
      name: "achievements",
      url: "/achievements",
      icon: <EmojiEvents />,
    },
    {
      name: "settings",
      url: "/settings",
      icon: <Settings />,
    },
  ],
  topNav: [
    {
      name: "Blog",
      url: "/blog/",
      icon: <Notes />,
    },
    // {
    //   name: 'Docs',
    //   url: 'https://api.nualang.fathominnovation.com',
    //   icon: <GroupWork />
    // }
    // {
    //   divider: true
    // },
  ],
};

export default nav;
